import { Answer } from "../../types/Answer";

import React, { useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

interface AnswerFormProps {
    answer: Answer;
    onAnswerChange: (answer: Answer) => void;
    onSubmit: () => void;
    onCancel: () => void;
}

const AnswerForm: React.FC<AnswerFormProps> = ({ answer, onAnswerChange, onSubmit, onCancel }) => {
    const [error, setError] = useState<boolean>(false);

    function onBodyChange(body: string) {
        onAnswerChange({ ...answer, body });
        setError(false);
    }

    function handleFormSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        if (!answer.body) {
            setError(true);
            return;
        }
        onSubmit();
    }

    return (
        <Box
            component="form"
            noValidate
            autoComplete="off"
            onSubmit={handleFormSubmit}
            onReset={onCancel}
            sx={{ display: "grid" }}
        >
            <TextField
                id="answer-body"
                name="answer-body"
                label="Your Answer"
                multiline
                error={error}
                helperText={error ? "Answer cannot be empty" : ""}
                value={answer.body}
                onChange={(event) => onBodyChange(event.target.value)}
                fullWidth
                margin="normal"
                sx={{
                    ".MuiInputBase-input": { fontSize: "large" },
                }}
            />
            <Stack direction="row" spacing={2}>
                <Button type="reset">Cancel</Button>
                <Button type="submit">Post</Button>
            </Stack>
        </Box>
    );
};

export default AnswerForm;
